import { connect } from 'react-redux';
import { searchSelectors, contactSelectors, currentUserSelectors } from '@lifesize/nucleus';
import LecturerSearch from 'components/LecturerSearch/LecturerSearch';
import { MEETING_FORM } from 'components/ContactModal/MeetingForm';
import { LECTURER_LABEL } from 'components/LecturerSearch/LecturerSearchBar';
import actions from 'actions/ContactModal';
import { change } from 'redux-form';
import _isEmpty from 'lodash/isEmpty';
import _reject from 'lodash/reject';
import _get from 'lodash/get';

const searchResults = [];

function getMaxItems({ allContacts, searchContacts, searchString }) {
  const searchLength = searchContacts.length ? searchContacts.length - 1 : 0;
  const resultLength = searchLength
    || (searchString ? 1 : 0)
    || allContacts.length;
  return Math.min(resultLength, 6);
}

function getContact(state, isFocused) {
  if (Object.keys(_get(state, 'app.contactModal.lecturer')).length) {
    return _get(state, 'app.contactModal.lecturer');
  } else if (Object.keys(_get(state, 'app.contactModal.oldLecturer')).length && !isFocused) {
    return _get(state, 'app.contactModal.oldLecturer');
  }
  return {};
}

function mapStateToProps(state) {
  const searchString = _get(state, 'app.form.lecturerSearch.values.name');
  const isFocused = _get(state, 'app.contactModal.isLecturerFocused');
  const contact = getContact(state, isFocused);
  const selfResult = currentUserSelectors.myInfo(state);
  let allContacts = contactSelectors.potentialLecturers(state);
  let searchContacts = searchSelectors.searchLecturers(state);
  const initialValues = contact;
  const selectionIndex = _get(state, 'app.dropdown.selectionIndex');
  let selectedContact;
  if (selectionIndex === 0) {
    selectedContact = { isNullContact: true };
  } else if (searchContacts.length) {
    selectedContact = _get(searchContacts[selectionIndex - 1], 'contact');
  } else {
    selectedContact = allContacts[selectionIndex - 1];
  }

  if (!_isEmpty(selfResult)) {
    selfResult.isSelf = true;
    allContacts = _reject(allContacts, { id: selfResult.id });
    allContacts.unshift(selfResult);

    // if there is at least one value, also return selfResult as the first value
    if (searchContacts.length) {
      searchContacts = _reject(searchContacts, { contact: { id: selfResult.id } });
      searchContacts.unshift({ contact: selfResult });
    }
  }

  let searchLength;
  if (searchContacts.length === 0) {
    searchLength = allContacts.length + 1;
  } else {
    searchLength = searchContacts.length + 1;
  }

  if (searchResults.length !== searchLength) {
    searchResults.length = searchLength;
  }

  return {
    allContacts,
    maxItems: getMaxItems({ allContacts, searchContacts, searchString }),
    searchContacts,
    isFocused,
    contact,
    searchString,
    initialValues,
    selectedContact,
    searchResults
  };
}

const mapDispatchToProps = dispatch => ({
  handleSelectContact: (contact) => {
    dispatch(actions.setLecturer(contact));
    dispatch(actions.setLecturerFormFocus(false));
  },
  handleResetContact: () => {
    dispatch(actions.unsetLecturer(true));
    dispatch(actions.setLecturerFormFocus(false));
  },
  handleSetIsFocused: (isFocused) => {
    if (isFocused) {
      dispatch(actions.unsetLecturer());
    }
    dispatch(actions.setLecturerFormFocus(isFocused));
  },
  handleEnter: (selectedContact) => {
    if (!selectedContact) return;
    if (selectedContact.isNullContact) {
      dispatch(change(MEETING_FORM, LECTURER_LABEL, selectedContact));
      dispatch(actions.unsetLecturer(true));
      dispatch(actions.setLecturerFormFocus(false));
    } else {
      dispatch(change(MEETING_FORM, LECTURER_LABEL, selectedContact));
      dispatch(actions.setLecturer(selectedContact));
      dispatch(actions.setLecturerFormFocus(false));
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(LecturerSearch);
